import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { motion } from 'framer-motion';
import CustomCruiseIcon from '../components/CustomCruiseIcon';

const NotFound = () => {
  return (
    <motion.div 
      className="text-center py-12"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex justify-center mb-6">
        <motion.div
          initial={{ rotate: 0 }}
          animate={{ rotate: [0, 10, -10, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        >
          <CustomCruiseIcon size={160} className="text-teal-500" />
        </motion.div>
      </div>
      
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
      <p className="text-gray-600 max-w-md mx-auto mb-8">
        Looks like you've sailed into uncharted waters. The page you're looking for may have been moved or doesn't exist.
      </p>
      
      <Link
        to="/"
        className="inline-flex items-center px-6 py-3 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition duration-200"
      >
        <Home className="h-5 w-5 mr-2" />
        Back to Home
      </Link>
    </motion.div>
  );
};

export default NotFound;